import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { PlacementService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss'],
  providers:[PlacementService,AppGlobals,MasterService]
})
export class PostsComponent implements OnInit {

  studentarr:any[];
  depts:any[];
  catgories:any[];
 
  @ViewChild('dt') table: any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrcanlst:any=[];
  sections:any=[];
  bloodgp:any=[];
  castecats:any=[];
  subcomb:any=[];
  oprtype:string;
  filtcatgory:any[];
  arhouse:any=[];
  aylist:any[];
  arrposts:any=[];
  arfeequota:any=[];
  armot:any=[];
  arrcourse:any=[];
  objstudent:any;
  admdash:any={};
  arrapplied:any=[];
  arralotins:any=[];
  arrinstutes:any=[];
  objjob:any={};
  arrstudoctype:any=[];
  infocnt:any={};
  
  arrinsdview:any=[];
  arrjopdview:any=[];
  arralotinsclass:any=[];
  stuid;
  jpid;
  selnst:any;
  //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
  tab=1;
  tab1=1;
  selcat:any=0;
  verifiedstatus:any;
  genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
  statuses:any=[{value:'YES',name:'YES'},{value:'NO',name:'NO'}];

  fileToUpload: File = null;

fData: FormData = new FormData;
dcid:any=0;
arrstudoc:any=[];
disuploadbtn=true;
completeDate: Date;
localCompleteDate: string;
  fnm: any;
  arrstudocupd: any;
  //modalOption: NgbModalOptions = {};
  //filteredOptions: Observable<any[]>;
  constructor(private http: HttpClient, private mservice:MasterService,private pservice: PlacementService,private modalService: NgbModal,private apglobal:AppGlobals) {

    this.completeDate = new Date();
    this.localCompleteDate = this.completeDate.toISOString();
    this.localCompleteDate = this.localCompleteDate.substring(0, 16);
   }

 

 

    

  ngOnInit(): void {
   this.overview();
  this.getjobposts();

  }
 
 
  getcomplist() {
    this.pservice.getcompanies()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrcanlst = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getjobposts() {
    this.pservice.getjobposts()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrposts = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getapplied(jpid,insid) {
    debugger
    this.pservice.getapplied(jpid,insid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            
            if(resultArray == undefined)
            {
              this.arrapplied =[];
            }
            else{
              resultArray.forEach(x => x.selstatus = x.selstatus === 'Selected');
            this.arrapplied = resultArray;
            }
           
        },
        error => console.log("Error :: " + error)
        )
  }

  downapplied(jpid,insid,stuid) {
    debugger
    this.pservice.downloadappprofile(jpid,insid,stuid)
    .subscribe(res => {
      //console.log('start download:',res);
      var url = window.URL.createObjectURL(res.data);
      
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = res.filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }, error => {
      //console.log('download error:', JSON.stringify(error));
    }, () => {
      //console.log('Completed file download.')
    });
  }


  onchangecat(e,obj)
{

  console.log(obj);
  //console.log(obj);
  // this.categorymodel=obj;
  // this.categorymodel.status=e.checked;
  // this.categorymodel.oprtype='updstatus';
  // this.SavecatDetails();
  if(e.checked)
  {
    var status="Selected";
  }
  else {
    var active="Applied";
  }
  var pst={jpid:obj.jpid,status:status,stuid:obj.stuid,insid:obj.insid};

  this.pservice.updateplacementsel(obj.jpid,obj.insid,obj.stuid,status)
  .subscribe(
  result => {
      console.log('SavegenmasDetails', result);
      //this.suppliers = resultArray;
      alert(result.message);
      
  },
  error =>{ alert('Error While saving...');}
  )
}


  exportcandidate(jpid,insid){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.pservice.callurl+"export/expapplied_candidates.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&jpid="+jpid;
  
    // window.open(url,'','_blank');
    window.open(url);
   }


  
  getinsalloted(jpid) {
    
    this.pservice.getinsalloted(jpid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arralotins = resultArray;

            this.arrinstutes = resultArray.filter(item => item.ctag=='1');
            this.selnst=this.arrinstutes[0].id;
            this.getapplied(jpid,this.arrinstutes[0].id);
        },
        error => console.log("Error :: " + error)
        )
  }


  getinsallotedclass(jpid) {
    
    this.pservice.getinsallotedclass(jpid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arralotinsclass = resultArray;

           // this.arralotinsclass = resultArray.filter(item => item.ctag=='1');
            //this.selnst=this.arralotinsclass[0].id;
            //this.getapplied(jpid,this.arrinstutes[0].id);
        },
        error => console.log("Error :: " + error)
        )
  }

    
  overview() {
    
    this.pservice.getpostoverview()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.infocnt = resultArray.placeinfocnt;
            this.arrinsdview = resultArray.arrinsdview;
            this.arrjopdview = resultArray.arrjopdview;

            
        },
        error => console.log("Error :: " + error)
        )
  }
  printprofile(insid,stuid){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.pservice.callurl+"qrcode/candidateprofile.php?clcd="+clcd+"&aycd="+aycd+"&insid="+insid+"&stuid="+stuid;
  
    // window.open(url,'','_blank');
    window.open(url);
   }
  onchange(obj) {
    debugger
    if (obj.ctag==false)
    {
      this.oprtype="del";
    }
    else if(obj.ctag==true)
    {
      this.oprtype="ins";
    }
    this.pservice.saveinsallotment(this.jpid,obj.id,this.oprtype,obj.classid)
        .subscribe(
        resultArray => {
            alert(resultArray.message);
            this.getinsallotedclass(this.jpid);
           
        },
        error => {console.log("Error :: " + error);
      alert('Error while allocation');
      }
        )
  }
  opendlgpost(content,formdata,cmd) {
    console.log("formdata",formdata);
    this.getcomplist();
  
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objjob={};
         this.objjob.oprtype=cmd;
      this.objjob.jpid=0;
      this.objjob.jpdt=this.localCompleteDate;
      this.objjob.lastdt=this.localCompleteDate;
      this.objjob.cpid=0;
      this.objjob.jobtitle='';
      this.objjob.salpkg='';
      this.objjob.jobdis='';
      this.objjob.active='YES';
      

      
      
    }
    else if (cmd=='update')
    {
      //this.getstudentdata('s_id',formdata)
      this.objjob=formdata;
      this.objjob.oprtype=cmd;
  
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }
  
  openapplied(content,jpid) {
   
    this.jpid=jpid;
    // this.getapplied(jpid,this.selnst);
    this.getinsalloted(jpid);
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }


  openallotment(content,jpid) {
   
    this.jpid=jpid;
    this.getinsallotedclass(jpid);
  
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           
       });
      
    
  }
  save_plajobpostingh(objjob)
{
  debugger;

 
  console.log(JSON.stringify(objjob));
  

  this.pservice.save_plajobpostingh(objjob)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.getjobposts();
//this.getstudents('s',0);

}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );

}


openinfo(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
// this.getnoteda(nfid);
  this.jpid=nfid;
  this.fnm='';
  this.getnotecls(this.jpid);
  // this,this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       
    });
}


upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);

   if(files==null || files==undefined)
  {
    this.disuploadbtn=true;
  }
  else{
    this.disuploadbtn=false;
  }

  this.fData.append("jpid", this.jpid.toString());
  this.fData.append("fnm", this.fnm.toString());
  // this.fData.append("ftype", this.ftype.toString());
  //this.fData.append("docpurpose", "Studentphoto");

  // this.SService.uploadFile(fData).subscribe(
  //     response => this.handleResponse(response),
  //     error => this.handleError(error)
  // )
}

fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.pservice.uploadplatemplate(this.fileToUpload,this.jpid,this.fnm)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
// this.fpath='';
this.fnm='';

this.getnotecls(this.jpid);
}
    
}, error => 
alert('error in connection')

);



}

getnotecls(stuid) {
  this.pservice.gettempuploads(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrstudoc = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}




delnoteda(stuid) {
  if(confirm("Are you sure you wan't to delete?"))
  {
  this.pservice.delplatemp(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          //this.arrstudoc = resultArray;
          alert(resultArray.message);
         this.getnotecls(this.jpid);
         
      },
      error => console.log("Error :: " + error)
      )
    }
}

getplastudocs(jpid,stuid) {
  this.pservice.getplastudocs(jpid,stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrstudocupd = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


showstudocs(content,stuid)
{

  // this.jpid=nfid;
  this.fnm='';
  this.getplastudocs(this.jpid,stuid);
  // this,this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'md'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       
    });
}


 openfiles(url:string){
  debugger
  window.open(url);
 }
}
